//TODO: TEMPORAL
import { FormControl, Grid } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  LocalizationProvider,
  TimePicker,
  renderTimeViewClock,
} from '@mui/x-date-pickers';
import { Control, Controller, FieldError, FieldErrorsImpl, Merge } from 'react-hook-form';
import { gridSize } from "@/shared";
import dayjs from "dayjs";
interface TimeClockComponenteFlotaProps {
  control: Control<any, any>;
  name: string;
  error: FieldError | Merge<FieldError, FieldErrorsImpl<{ [x: string]: any; }>> | undefined;
  helperText?: string;
  label: string;
  size?: {
    xs: number;
    sm: number;
    md: number;
    lg: number;
  }
  defaultValue?: string | null;
  enableDateTypeResult?: boolean;
  format?: string;
  showTimeViewClock?: boolean;
  onChangeValue?: (value: any) => void;
  enableFlota?: boolean;
  isPM?: boolean;
  isAm?: boolean;
  disabled?: boolean;

}

export default function TimeClockComponenteFlota({ control,
  name,
  error,
  label,
  helperText,
  size = gridSize,
  defaultValue,
  format = 'HH:mm',
  showTimeViewClock = true,
  onChangeValue,
  isPM = false,
  isAm = false,
  disabled = false
}: Readonly<TimeClockComponenteFlotaProps>) {

  return (
    <Grid item {...size}>
      <FormControl fullWidth>
        <Controller
          control={control}
          name={name}
          defaultValue={defaultValue ?? ''}
          render={({ field }) => {

            const onChange = (time: any) => {
              onChangeValue && onChangeValue(dayjs(time).format('HH:mm:ss'));
              field.onChange(dayjs(time).format('HH:mm:ss'));
            };

            return (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <TimePicker
                  {...field}
                  disabled={disabled}
                  value={field.value ? dayjs(`2024-01-01 ${field.value}`) : null}
                  minTime={
                    isAm
                      ? dayjs().hour(0).minute(0)
                      : isPM
                        ? dayjs().hour(12).minute(0)
                        : null
                  }
                  maxTime={
                    isAm
                      ? dayjs().hour(11).minute(0)
                      : isPM
                        ? dayjs().hour(23).minute(0)
                        : null
                  }
                  ampm={true}
                  label={label}
                  slotProps={{
                    textField: {
                      error: !!error,
                      required: true,
                      helperText: helperText,
                    },
                  }}

                  views={['hours', 'minutes']}
                  format={format}
                  viewRenderers={{
                    hours: showTimeViewClock ? renderTimeViewClock : null,
                    minutes: showTimeViewClock ? renderTimeViewClock : null,
                    seconds: showTimeViewClock ? renderTimeViewClock : null,
                  }}
                  onChange={onChange}
                />
              </LocalizationProvider>
            );
          }}
        />
      </FormControl>
    </Grid>
  )

}